import * as React from "react";
import {none, option} from "ts-option";
import {FormGroupProps} from "../../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../../common/props/PlaceholderProps";
import AssetSpecification from "../../../../model/asset/AssetSpecification";
import AssetSpecificationItemsView from "./AssetSpecificationItemsView";
import FormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/FormGroup";

type Props = FormGroupProps<AssetSpecification[]> & PlaceholderProps;

/**
 * Select asset specification form view group.
 */
export default class AssetSpecificationFormGroup extends React.PureComponent <Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<AssetSpecificationItemsView items={this.props.field.getOptionalValue().getOrElse([])}
											 onChange={this.onChange}/>
			</FormGroup>
		);
	}

	/**
	 * Callback on changed asset specification
	 * @param data
	 */
	onChange(data: AssetSpecification[]) {
		this.props.onChange(this.props.field.updateValue(data.length ? option(data) : none))
	}
}
